export default __webpack_public_path__ + "static/media/a2de3b36-8895-4e7a-93c4-3a072ca12d17.6743e62d.ttf";